$(() => {
  $('button[type="submit"]').click(function (e) {
    setTimeout(() => {
      const buttons = $('button[type="submit"]');

      buttons.loading();
    }, 0);
  });
});
